import { useEffect, useState } from "react";

const Input = (p) => {

    const [input, setInput] = useState(p.value);

    const onChange = (e) => {
        if (e.target.value) {
            setInput(e.target.value);
        } else {
            setInput('');
        }
    };

    useEffect(() => {
        setInput(p.value);
    }, [p.value]);

    return (
        <div className="CollectionInputBar_input">
            <label>
                <span>{p.label}</span>
                <input type="text" name={p.label} value={input} onChange={onChange} placeholder={p.placeholder} />
            </label>
        </div>
    );
};

export default Input;